<template>
    <div>
        <!--v-alert
            dark
            color="purple"
            icon="mdi-alert-outline"
        >
            Benvindo ao novo módulo de imóveis do sistema AYT. <br />
            Adicionamos algumas melhorias principalmente na <span class="font-weight-bold"> visualização da ficha, regras de acesso e visualização no celular. </span><br />
            Para maiores informações entre em contato com AYT.

        </v-alert-->

        <v-container>
            <v-row 
                :dense="$vuetify.breakpoint.xsOnly"
            >
                <v-col cols="12" xs="1" sm="1" md="4" lg="4" xl="4">

                </v-col> 
                <v-col cols="12" xs="11" sm="11" md="4" lg="4" xl="4">
                    <alert-component :alert="alerts.choice"></alert-component>
                </v-col>
                <v-col cols="12" xs="1" sm="1" md="4" lg="4" xl="4">
                    
                </v-col>  
            </v-row>            
            <v-row>
                <v-spacer />
                <v-col cols="12" xs="11" sm="11" md="5" lg="5" xl="5">
                    <v-btn
                        dark
                        color="pink"
                        block
                        :to="{ 
                            name: 'admin.properties2.store', 
                        }"
                        v-if="can('Cadastra imóvel')"
                    >
                        Cadastrar um novo imóvel
                    </v-btn>
                </v-col> 
                <v-spacer />   
            </v-row>
            <v-row>
                <v-spacer />
                <v-col cols="12" xs="11" sm="11" md="5" lg="5" xl="5">
                    <v-btn
                        color="primary"
                        block
                        :to="{ 
                            name: 'admin.properties2.filter', 
                        }"
                    >
                        Pesquisar um imóvel
                    </v-btn>
                </v-col> 
                <v-spacer/>    
            </v-row>
            <v-row>
                <v-spacer />
                <v-col cols="12" xs="11" sm="11" md="5" lg="5" xl="5">
                    <v-btn
                        :color="'Ativo' | statusProperty"
                        block
                        :to="{ 
                            name: 'admin.properties2.search',
                            query: {
                                status: 'Ativo'
                            } 
                        }"
                    >
                        Imóveis ativos
                    </v-btn>
                </v-col> 
                <v-spacer/>    
            </v-row>
            <v-row>
                <v-spacer />
                <v-col cols="12" xs="11" sm="11" md="5" lg="5" xl="5">
                    <v-btn
                        :color="'Desatualizado' | statusProperty"
                        block
                        :to="{ 
                            name: 'admin.properties2.search',
                            query: {
                                status: 'Desatualizado',
                                page: 1
                            } 
                        }"
                    >
                        Imóveis desatualizados
                        <span class="ml-1" v-if="me.profile != 'Master' && me.profile != 'Gerente'">
                             da carteira
                        </span>
                    </v-btn>
                </v-col> 
                <v-spacer />   
            </v-row>
            <v-row>
                <v-spacer />
                <v-col cols="12" xs="11" sm="11" md="5" lg="5" xl="5">
                    <v-btn
                        :color="'Pendente' | statusProperty"
                        block
                        :to="{ 
                            name: 'admin.properties2.search',
                            query: {
                                status: 'Pendente',
                                page: 1
                            } 
                        }"
                    >
                        Imóveis pendente 

                        <span class="ml-1" v-if="me.profile != 'Master' && me.profile != 'Gerente'">
                             da carteira
                        </span>
                        
                    </v-btn>
                </v-col> 
                <v-spacer />
            </v-row>
            <v-row v-if="me.profile == 'Master' || me.profile == 'Gerente'">
                <v-spacer />
                <v-col cols="12" xs="11" sm="11" md="5" lg="5" xl="5">
                    <v-btn
                        color="yellow"
                        block
                        :to="{ 
                            name: 'admin.properties2.property_portal_summary'
                        }"
                    >
                         Imóveis por portal    
                        <v-chip
                            class="ma-2"
                            x-small
                            color="pink"
                            label
                            dark
                        >
                            NOVO
                        </v-chip>                    
                    </v-btn>
                </v-col> 
                <v-spacer />
            </v-row>
            <v-row v-if="me.profile == 'Master'">
                <v-spacer />
                <v-col cols="12" xs="11" sm="11" md="5" lg="5" xl="5">
                    <v-btn
                        color="#F7D6FF"
                        block
                        :to="{ 
                            name: 'admin.properties2.shop_windows'
                        }"
                    >
                         Vitrine do Website    
                        <v-chip
                            class="ma-2"
                            x-small
                            color="pink"
                            label
                            dark
                        >
                            NOVO
                        </v-chip>                    
                    </v-btn>
                </v-col> 
                <v-spacer />
            </v-row>
        </v-container>
    </div>
</template>

<script>
import AlertComponent from '@/components/alert/AlertComponent.vue'

import { mapGetters } from 'vuex';

export default {
    components: {
        AlertComponent
    }, 

    computed: {
         ...mapGetters('permissions', ['can']),

        me () {
          return this.$store.state.auth.me
        },
    },
    
    mounted() {
        window.scrollTo(0, 0);
    },

    data () {
        return {
            alerts: {
                choice: {
                    show: '',
                    type: 'warning',
                    icon: 'mdi-alert-outline',
                    messages: ['Escolha uma das opções abaixo.']
                },
            }

        }
    }            
}
</script>